import dashboardMiddleware from './dashboard.mdl';

export default [
    ...dashboardMiddleware
];